import { getService } from './service';
import { clearScrollPosition } from './ui/UiScrollReducer';

export const getPersonWarrantCount = async (ptsPersonID) => {
  const service = getService('ptswarrant');
  const result = await service.find({ query: { ptsPersonID, IsActive: 1, IsDeleted: 0 } });
  return result?.data.length || 0;
};

export const getPersonWarrant = (ptsPersonID) => {
  const service = getService('cad-search-warrants');
  return service.get(ptsPersonID);
};

export const SET_WARRANT_PAGINATION_PAGE = 'SET_WARRANT_PAGINATION_PAGE';
export const SET_WARRANT_PAGINATION_PAGE_SIZE = 'SET_WARRANT_PAGINATION_PAGE_SIZE';

export const setWarrantPaginationPage = (page) => (dispatch) => {
  dispatch(clearScrollPosition('WarrantList'));
  dispatch({ type: SET_WARRANT_PAGINATION_PAGE, payload: page });
};

export const setWarrantPaginationPageSize = (pageSize) => (dispatch) => {
  dispatch(clearScrollPosition('WarrantList'));
  dispatch({ type: SET_WARRANT_PAGINATION_PAGE, payload: 0 });
  dispatch({ type: SET_WARRANT_PAGINATION_PAGE_SIZE, payload: pageSize });
};

const INITIAL_STATE = {
  pagination: { page: 0, pageSize: 25 },
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_WARRANT_PAGINATION_PAGE:
      return { ...state, pagination: { ...state.pagination, page: action.payload } };
    case SET_WARRANT_PAGINATION_PAGE_SIZE:
      return { ...state, pagination: { ...state.pagination, pageSize: action.payload } };
    default:
      return state;
  }
}
